<template>
  <div>
    <headers :tabIndex="1"></headers>
    <div class="inRegard-banner">
        <p class="inRegard-banner-title2">预应力品质工程践行者</p>
        <p class="inRegard-banner-title">交达长期聚焦预应力工程检测细分领域的专业化技术沉淀，从事检测服务、装备开发、科学研究和技术咨询业务</p>

        <img class="img1" src="@/assets/imgs/wap/5.png" />
    </div>

    <div class="inRegard-content">
        <p class="title1">交达预应力 - 预应力品质工程践行者</p>

        <div class="inRegard-box">
          <div class="li">
            <img class="img1" src="@/assets/imgs/home/1-1.png" />
            <span class="sp1">价值观</span>
            <span class="sp2">利他、专注、科技</span>
          </div>
          <div class="li">
            <img class="img1" src="@/assets/imgs/home/1-2.png" />
            <span class="sp1">使命</span>
            <span class="sp2">提升工程品质，杜绝质量隐患</span>
          </div>
          <div class="li">

            <img class="img1" src="@/assets/imgs/home/1-3.png" />
            <span class="sp1">愿景</span>
            <span class="sp2">全数量检测的引领者</span>
          </div>
        </div>


        <div class="inRegard-box2">
          <!--          <p class="title2">关于交达</p>-->

          <div class="flex">
            <div class="inRegard-box2-left">
              <div class="left-li">
                <p>四川交达</p>
                <span>四川交达预应力工程检测科技有限公司（简称：四川交达）是一家在预应力工程领域内专业从事检测服务、装备开发、科学研究和技术咨询业务的高新科技企业。</span>
              </div>
              <div class="left-li">
                <p>全数量检测新模式</p>
                <span>四川交达致力于通过数字化技术重新定义预应力工程，开启全数量检测新模式，提供全新解决方案，带动工程检测升级换代和数字化转型，促进工程行业高质量发展。</span>
              </div>
              <div class="left-li">
                <p>产学研融政，坚持开放创新，打造专业生态</p>
                <span>四川交达凝聚联合“双一流”高校、研究院所、行业龙头企业等顶尖团队与人才，融合产学研融政，坚持开放创新，打造专业生态，成就合作伙伴。公司以长期聚焦预应力工程检测细分领域的“专业化”技术积淀，以数据驱动工程质量管控向“精细化”发展，开启工程质量全数量无人化检测的“特色化”新模式，引领工程质量检测与管控的数字化转型迈向品质提升的“新颖化”发展之路。公司将始终秉持“专精特新”之道，为行业、客户、合作伙伴及员工提供值得信赖的全新解决方案与高质量服务，并共同引领行业持续、健康、高质量发展，创造更多、更大的价值。</span>
              </div>
            </div>
            <div class="inRegard-box2-right"></div>
          </div>

        </div>

      </div>
    <div class="map-box">
      <div class="flex-sp" style="height: 100%">
        <div class="map-box-text">
          <div class="map-box-li">
            <span class="flex" style="align-items: center;color: #0071EF">10+<span style="font-size:0.36rem">年</span></span>
            <p>预应力检测技术研发积累</p>
          </div>
          <div class="map-box-li">
            <span class="flex" style="align-items: center;color: #0071EF">100+<span style="font-size:0.36rem">个</span></span>
            <p>基础设施建设项目实践</p>
          </div>
          <div class="map-box-li">
            <span class="flex" style="align-items: center;color: #0071EF">1000+<span style="font-size:0.36rem">项</span></span>
            <p>具体工程（桥梁、边坡、隧道等）应用</p>
          </div>
          <div class="map-box-li">
            <span class="flex" style="align-items: center;color: #0071EF">1,000,000+<span style="font-size:0.36rem">孔</span></span>
            <p>现场工程结构检测数据积累</p>
          </div>
          <div class="map-box-li">
            <span class="flex" style="align-items: center;color: #0071EF">100,000,000+<span style="font-size:0.36rem">条</span></span>
            <p>工程大数据挖掘分析与验证</p>
          </div>
        </div>
      </div>
    </div>
<!--      <div class="inRegard-box3">-->
<!--          <p class="box3-title">业务体系</p>-->
<!--          <span class="box3-detail">四川交达在公路、铁路、市政、水利、矿山、地产等基建行业，对于广泛采用预应力技术的桥梁、边坡、隧道、基坑、巷道、建筑等重大基础设施工程结构，针对客户与合作伙伴（行政主管部门、建设单位、施工单位、监理单位等各方）在建设过程中长期面临的质量安全上的控制难、损失大、风险高、责任重等问题，为客户提供特色检（监）测、特殊试验、科研项目、产品研发、技术咨询、数据服务、技术培训等类型的相关业务。</span>-->
<!--          <div style="position: relative">-->
<!--            <img src="@/assets/imgs/inRegard/1.png" />-->
<!--          </div>-->
<!--        </div>-->
    <footers></footers>
  </div>
</template>


<script>
  import headers from "@/components/wap/header1"
  import footers from "@/components/wap/footer"
  import axios from "axios";
  export default {
    name: 'wapInRegard',
    components:{headers,footers},
    data() {
      return{
      }
    },
    mounted() {
    },
    beforeDestroy() {
    },
    methods:{}
  }
</script>

<style scoped>
  .map-box{
    background-color: #F1F3F9;
    padding: 0.4rem 0.72rem;
    width: 100%;
    box-sizing: border-box;
  }
  .map-box .map-box-li{
    font-size: 0.48rem;
    font-family: Titillium Web-Bold, Titillium Web;
    font-weight: bold;
    margin-bottom: 0.4rem;
  }
  .map-box .map-box-li p{
    font-size: 0.28rem;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
    margin-top: 0.2rem;
  }

  .inRegard-banner{
    width: 100%;
    height: 13.34rem;
    padding-top: 1rem;
    box-sizing: border-box;
    background-color: #19203B;
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
  }
  .inRegard-banner img{
    width: 100%;
    position: absolute;
    left: 0;
    top: 0rem;
    z-index: 0;
    object-fit: cover;
  }
 .inRegard-banner .inRegard-banner-title2{
   font-size: 0.48rem;
   font-family: PingFang SC-Heavy, PingFang SC;
   font-weight: 800;
   color: #19203b;
   padding:0 0.68rem;
   margin-top: 1.2rem;
   animation-name: fadeInUp;
   animation-duration:1s;
   animation-timing-function:ease;
   position: relative;

   z-index: 2;
  }
  .inRegard-banner .inRegard-banner-title{
    width: 5.4rem;
    margin: 0.8rem 0 0;
    font-size: 0.28rem;
    padding:0 0.68rem;
    position: relative;
    z-index: 2;
    animation-name: fadeInUp;
    animation-duration:1s;
    animation-delay: 1s;
    animation-timing-function:ease;
    animation-fill-mode:forwards;
    opacity: 0;
    line-height: 2;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;

    color: #19203b;
  }
  .inRegard-content{
    padding: 0.6rem 0.72rem;
  }
  .inRegard-content .title1{
    font-size: 0.36rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    text-align: center;
    color: #19203B;
  }
  .inRegard-content .inRegard-box{
    margin-top: .4rem;
  }
  .inRegard-content .inRegard-box .li{
    width: 6.04rem;
    height: 3.4rem;
    background: #F1F3F9;
    text-align: center;
    margin-bottom: 0.2rem;
  }
  .inRegard-content .inRegard-box .li img{
    width: 1.34rem;
    margin-top: 0.4rem;
  }

  .inRegard-content .inRegard-box .sp1{
    font-size: 0.32rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    display: block;
    color: #19203B;
  }
  .inRegard-content .inRegard-box .sp2{
    font-size: 14px;
    display: block;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #808080;
    margin-top: 0.08rem;
  }
  .inRegard-box2-left .left-li{
    font-size: 0.28rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #5C5D5F;
  }
  .inRegard-box2-left .left-li p{
    font-size: 0.32rem;
    margin: 0.4rem 0 0.2rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #19203B;
  }
  .inRegard-box2-left .left-li span{
    line-height: 1.8;
  }

  .inRegard-box3{
    width: 100%;
    padding: 0.4rem 0.72rem;
    box-sizing: border-box;
    background: #F2F4F9;
  }
  .inRegard-box3 .box3-title{
    font-size: 0.36rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    text-align: center;
    color: #19203B
  }
  .inRegard-box3 .box3-detail{
    font-size: 0.28rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #5C5D5F;
    line-height: 1.8;
    display: block;
    margin-top: 0.4rem;
  }
  .inRegard-box3 img{
    width: 5.92rem;
    margin-top: 0.4rem;
  }
</style>



// WEBPACK FOOTER //
// src/view/inRegard/wapIndex.vue